export default "__VITE_ASSET__$OUJhcZM__"